<script setup>
import util from '@/util';
import { useRouter } from 'vue-router/composables';
import { CONTEXT, MOBILE_WIDTH } from '@/const';

const router = useRouter();

const isInIframe = () => self !== top;
const isMobile = () => {
  const checkUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  const checkWidth = innerWidth <= MOBILE_WIDTH;
  const checkSearch = util.getURLSearchParam('wap') === '1';
  return checkUA || checkWidth || checkSearch;
};

if (isInIframe() || !isMobile()) {
  util.jumpTo(`${CONTEXT.uniportal}/login-pc.html`);
} else {
  const params = util.toSearchString(util.assembleParams(new URLSearchParams(location.search)));
  location.href = `${location.origin + CONTEXT.uniportal}/loginV2/index.html${params}#/mobile`;
}
</script>

<template>
  <div></div>
</template>

<style scoped></style>
